<div class="flex min-h-[calc(100vh-12rem)] items-start justify-center pt-16">
  <div class="flex w-full max-w-md flex-col items-center rounded-2xl bg-white px-8 py-10 text-center shadow-sm ring-1 ring-gray-900/5">
    <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 text-primary-500">
      <app-icon name="building-office" size="lg" />
    </div>

    <h2 class="mt-5 text-xl font-semibold text-gray-900">No Facility Selected</h2>
    <p class="mt-2 text-sm leading-relaxed text-gray-500">{{ message() }}</p>

    <div class="mt-6 flex flex-col items-center text-gray-400">
      <app-icon name="chevron-up" size="sm" />
      <span class="mt-1 text-xs uppercase tracking-wider">Use the header dropdowns</span>
    </div>
  </div>
</div>
